import { logEvent } from 'commons/utils/tracking';
import { MENU_PRIMARY_GOOGLE_SHOPPING_CLICK } from 'config/trackingEvents';

export const menuPrimaryGoogleShoppingClick = () => {
  logEvent(MENU_PRIMARY_GOOGLE_SHOPPING_CLICK, {});
};
